import { useEffect, useState } from "react";
import LoaderComponent from "../../Common/LoaderComponent";
import {
  hideAbacNavLoader,
  subscribeAbacNavLoader,
} from "./abacNavLoader";

const MAX_LOADER_MS = 20000;

/**
 * Host for the Manage → ABAC navigation loader.
 * Mount once in the app shell so it survives the Multi Access modal closing.
 */
export default function AbacNavLoaderHost() {
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeAbacNavLoader(setVisible), []);

  useEffect(() => {
    if (!visible) return undefined;
    const timer = window.setTimeout(() => {
      hideAbacNavLoader();
    }, MAX_LOADER_MS);
    return () => window.clearTimeout(timer);
  }, [visible]);

  if (!visible) return null;
  return <LoaderComponent inline={false} />;
}
